import React, { useEffect, useState, useRef } from "react";
import LoadingSpinner from "../../../../Components/LoadingSpinner/LoadingSpinner";
import { useDispatch, useSelector } from "react-redux";
import { ResetLoginSignUp } from "../../../../Actions/ToggleSignupA";
import PartnerRegisteration from "./PartnerRegisteration";
import OwnerRegisteraion from "./OwnerRegisteration";
import PackageSelectionDesign from "./PackageSelection";
import InstituteDataReview from "./InstituteDataReview";
import OwnersDataReview from "./OwnerDataReview";
import InstituteSubmissionScreen from "./SubmissionScreen";
import InstituteTermAndConditions from "./TermsAndConditions";
import { RegisterNewInstituteA } from "../../../../Actions/UserA";
import CrossIcon from "../../Assets/CrossIcon.svg"; // at the top
import ReuseablePopup from "../../../../Components/ReuseablePopups/ReuseablePopup";
import SurePopupImg from "./Assets/SurePopup.png";
import errorMessageImage from "./Assets/errorMessage.png";


const InstituteNewSide = () => {
    const { error, loading } = useSelector((Store) => Store.LoginSignupReducer);
    const Border = "border-[#E2E2E2] border-[1px] border-solid";
    const [openSignupScreen, setOpenSignupScreen] = useState("PartnerRegisteration")

    const [InstituteData, setInstituteData] = useState({
      partnerData: {
          logo: null,
          banner: null,
          icon: null,
          businessRegistration: null,
          transportationRegistration: null,
          contactNumber: "",
          emergencyNumber: "",
          emergencyEmail: "",
          email: "",
          website: "",
          businessName: "",
          postalCode: "",
          country: "",
          province: "",
          city: "",
          Address: "",
      },
  });
  const [isUpdationFailedPopup, setIsUpdationFailedPopup] = useState(false);
  const [errorMessageText, setErrorMessageText] = useState("Something Went Wrong");

  const initialInstituteDataRef = useRef(JSON.stringify(InstituteData));

  const hasFormChanged = () => {
    return JSON.stringify(InstituteData) !== initialInstituteDataRef.current;
  };
  

  //   const [InstituteData, setInstituteData] = useState({
  //     partnerData: {
  //         logo: null,
  //         banner: null,
  //         icon: null,
  //         businessRegistration: null,
  //         transportationRegistration: null,
  //         contactNumber: "",
  //         emergencyNumber: "",
  //         emergencyEmail: "",
  //         email: "",
  //         website: "",
  //         businessName: "",
  //         postalCode: "",
  //         country: "",
  //         province: "",
  //         city: "",
  //         Address: "",
  //     },
  //     ownersData: {
  //       ownerIdFront: null,
  //       ownerIdBack: null,
  //       ownerPicture: null,
  //       ownerSignatureImage: null,
  //       contactNumber: "",
  //       emergencyNumber: "",
  //       emergencyEmail: "",
  //       FirstName: "",
  //       LastName: "",
  //       email: "",
  //       postalCode: "",
  //       country: "",
  //       province: "",
  //       city: "",
  //       Address: "",
  //     },
  //     package: {}, // Store selected package details
  //     ownersSignature:"",
  // });
  
  // const [InstituteData, setInstituteData] = useState({
  //   partnerData: {
  //     logo: "dummy-logo.png",
  //     banner: "dummy-banner.png",
  //     icon: "dummy-icon.png",
  //     businessRegistration: "dummy-registration.pdf",
  //     transportationRegistration: "dummy-transportation.pdf",
  //     contactNumber: "+1234567890",
  //     emergencyNumber: "+0987654321",
  //     emergencyEmail: "emergency@example.com",
  //     email: "partner@example.com",
  //     website: "https://dummyinstitute.com",
  //     businessName: `Institute-business`,
  //     postalCode: "12345",
  //     country: "USA",
  //     province: "California",
  //     city: "Los Angeles",
  //     Address: "123 Dummy Street, Los Angeles, CA",
  //   },
  //   ownersData: 
  //     {
  //       ownerIdFront: "dummy-owner-id-front.png",
  //       ownerIdBack: "dummy-owner-id-back.png",
  //       ownerPicture: "dummy-owner-picture.png",
  //       ownerSignatureImage: "dummy-owner-signature.png",
  //       contactNumber: "+1112223333",
  //       emergencyNumber: "+4445556666",
  //       emergencyEmail: "owneremergency@example.com",
  //       FirstName: "Johnnnnn",
  //       LastName: `Does`,
  //       email: "owner@example.com",
  //       postalCode: "54321",
  //       country: "USA",
  //       province: "New York",
  //       city: "New York City",
  //       Address: "456 Owner Lane, New York, NY",
  //     },
  //   package: {
  //     id: "Package1", // Unique package ID
  //     name: "Premium Package",
  //     price: 499.99,
  //     annualDiscount: 10, // 10% discount
  //     originalPrice: 599.99,
  //   },
  //   ownersSignature: "dummy-signature",
  // });

  const Dispatch = useDispatch();

//   const handleSubmit = async () => {
//     const formData = new FormData();

//     // Convert nested objects to JSON
//     formData.append("partnerData", JSON.stringify(InstituteData.partnerData));
//     formData.append("ownersData", JSON.stringify(InstituteData.ownersData));
//     formData.append("package", JSON.stringify(InstituteData.package));

//     // Append Files
//     formData.append("InstituteLogo", InstituteData.partnerData.logo);
//     formData.append("Institute_Banner", InstituteData.partnerData.banner);
//     formData.append("LR_Slip", InstituteData.partnerData.businessRegistration);
//     formData.append("MOTR_Slip", InstituteData.partnerData.transportationRegistration);
//     formData.append("Icon", InstituteData.partnerData.icon);
//     formData.append("OwnerIdFront", InstituteData.ownersData.ownerIdFront);
//     formData.append("OwnerIdBack", InstituteData.ownersData.ownerIdBack);
//     formData.append("OwnerPicture", InstituteData.ownersData.ownerPicture);
//     formData.append("OwnerSignatureImage", InstituteData.ownersData.ownerSignatureImage);

//     Dispatch(RegisterNewInstituteA(formData, () => {
//         console.log("Institute Registered Successfully!");
//         setOpenSignupScreen("SubmissionScreen");
//     }));
// };

const handleSubmit = async () => {
  const formData = new FormData();

  // Convert nested objects to JSON (without files)
  const partnerDataWithoutFiles = { ...InstituteData.partnerData };
  // const ownersDataWithoutFiles = { ...InstituteData.ownersData };

  // Remove file objects before converting to JSON
  Object.keys(partnerDataWithoutFiles).forEach(key => {
      if (partnerDataWithoutFiles[key]?.file) delete partnerDataWithoutFiles[key];
  });
  // Object.keys(ownersDataWithoutFiles).forEach(key => {
  //     if (ownersDataWithoutFiles[key]?.file) delete ownersDataWithoutFiles[key];
  // });

  formData.append("partnerData", JSON.stringify(partnerDataWithoutFiles));
  // formData.append("ownersData", JSON.stringify(ownersDataWithoutFiles));
  // formData.append("package", JSON.stringify(InstituteData.package));

  // Append Files (Use `.file` instead of preview URL)
  if (InstituteData.partnerData.logo?.file) formData.append("InstituteLogo", InstituteData.partnerData.logo.file);
  if (InstituteData.partnerData.banner?.file) formData.append("Institute_Banner", InstituteData.partnerData.banner.file);
  if (InstituteData.partnerData.businessRegistration?.file) formData.append("LR_Slip", InstituteData.partnerData.businessRegistration.file);
  if (InstituteData.partnerData.transportationRegistration?.file) formData.append("MOTR_Slip", InstituteData.partnerData.transportationRegistration.file);
  if (InstituteData.partnerData.icon?.file) formData.append("Icon", InstituteData.partnerData.icon.file);
  // if (InstituteData.ownersData.ownerIdFront?.file) formData.append("OwnerIdFront", InstituteData.ownersData.ownerIdFront.file);
  // if (InstituteData.ownersData.ownerIdBack?.file) formData.append("OwnerIdBack", InstituteData.ownersData.ownerIdBack.file);
  // if (InstituteData.ownersData.ownerPicture?.file) formData.append("OwnerPicture", InstituteData.ownersData.ownerPicture.file);
  // if (InstituteData.ownersData.ownerSignatureImage?.file) formData.append("OwnerSignatureImage", InstituteData.ownersData.ownerSignatureImage.file);

  // Dispatch API Call
  Dispatch(RegisterNewInstituteA(formData, () => {
      console.log("Institute Registered Successfully!");
      setOpenSignupScreen("SubmissionScreen");
  },
  (errorMessage) => {
    // error callback — show popup here
    setErrorMessageText(errorMessage)
    setIsUpdationFailedPopup(true)
  }),
  );
};

// const initialInstituteDataRef = useRef(JSON.stringify({
//   partnerData: {
//     logo: null,
//     banner: null,
//     icon: null,
//     businessRegistration: null,
//     transportationRegistration: null,
//     contactNumber: "",
//     emergencyNumber: "",
//     emergencyEmail: "",
//     email: "",
//     website: "",
//     businessName: "",
//     postalCode: "",
//     country: "",
//     province: "",
//     city: "",
//     Address: "",
//   },
// }));

const [showPopup, setShowPopup] = useState(false);

// const handleCloseClick = () => {
//   const currentDataString = JSON.stringify(InstituteData);
//   const initialDataString = initialInstituteDataRef.current;

//   if (currentDataString !== initialDataString) {
//     setShowPopup(true);
//   } else {
//     Dispatch(ResetLoginSignUp(false));
//   }
// };

const handleDiscardClick = () => {
  Dispatch(ResetLoginSignUp(false));
};

    return !loading ? (
      <div
        style={{
          width: ["SubmissionScreen"].includes(openSignupScreen) ? "100%" : "100% lg:80%",
          backgroundColor: "white",
          // paddingTop: "2.5rem", // equivalent to pt-10
          paddingBottom: openSignupScreen === "PackageSelection" ? "1rem" : "4rem", // md:pb-4, xl:pb-8
          display: "flex",
          alignItems: "flex-start",
          height: "fit-content",
          overflowX: "hidden",
          position: "relative",
          borderRadius: openSignupScreen === "PackageSelection" ? "lg:21px" : "0",
        }}
        // className="md:bg-white md:pt-0"
        className={`w-full ${openSignupScreen === "ViewInstituteRegisterationData" ? "lg:w-[50%] 2xl:w-[40%]" : "lg:w-[100%]"}`}
>
      
          <div className="absolute top-2 right-2 "
            // onClick={() => setShowPopup(true)}
            onClick={() => {
              if (hasFormChanged()) {
                setShowPopup(true); // Show discard confirmation
              } else {
                handleDiscardClick(); // Immediately close if no changes
              }
          }}
            >
            <img
              className="absolute right-3 top-[6px] cursor-pointer w-[30px] h-[30px]"
              src={require("./Assets/InstituteCross.svg").default}
              alt="image"
            />
          </div>

          {showPopup && (
            <ReuseablePopup
                setShowPopup={setShowPopup}
                heading="Are you sure?"
                text="Are you sure you want to close? Any changes you've made will not be saved."
                btnText="Discard "
                // onClick={() => setShowPopup(false)} // <-- Add this line
                onClick={handleDiscardClick}
                imageSrc={SurePopupImg} // ✅ Dynamic image source
                />
        )}

        {isUpdationFailedPopup && (
                <ReuseablePopup
                setShowPopup={setIsUpdationFailedPopup}
                heading="Oops!"
                text={errorMessageText}
                btnText="Back"
                onClick={() => setIsUpdationFailedPopup(false)} // <-- Add this line
                imageSrc={errorMessageImage} // ✅ Dynamic image source
                />
            )}


         {openSignupScreen === "PartnerRegisteration" && (
            <PartnerRegisteration
            InstituteData={InstituteData}
            setInstituteData={setInstituteData}
            setOpenSignupScreen={setOpenSignupScreen} />
         )}

         {openSignupScreen === "OwnerRegisteration" && (
            <OwnerRegisteraion
            InstituteData={InstituteData}
            setInstituteData={setInstituteData}
            setOpenSignupScreen={setOpenSignupScreen} />
         )}

         {openSignupScreen === "PackageSelection" && (
            <PackageSelectionDesign
            setOpenSignupScreen={setOpenSignupScreen}
            InstituteData={InstituteData}
            setInstituteData={setInstituteData}
             />
         )}

         {openSignupScreen === "TermAndCondition" && (
            <InstituteTermAndConditions
            setOpenSignupScreen={setOpenSignupScreen}
            setInstituteData={setInstituteData}
            InstituteData={InstituteData} />
         )}

         {openSignupScreen === "ViewInstituteRegisterationData" && (
            <InstituteDataReview
            setOpenSignupScreen={setOpenSignupScreen}
            InstituteData={InstituteData}
            handleSubmit={handleSubmit}
             />
         )}

         {openSignupScreen === "OwnerDataReview" && (
            <OwnersDataReview
            setOpenSignupScreen={setOpenSignupScreen}
            InstituteData={InstituteData}
            handleSubmit={handleSubmit} />
         )}

         {openSignupScreen === "SubmissionScreen" && (
            <InstituteSubmissionScreen
            setOpenSignupScreen={setOpenSignupScreen}
            InstituteData={InstituteData} />
         )}
    
        </div>
      ) : (
        <LoadingSpinner />
      );
}

export default InstituteNewSide;
